// extracted by mini-css-extract-plugin
export default {"footerLink":"c-g_eh"};